import netWorkController from "@/http/netWorkController";
import cookieUtils from "@/utils/cookieUtils";
import toastUtils from "@/utils/toastUtils";
import stringUtils from "@/utils/stringUtils";
import aesUtils from "@/utils/aesUtils";

export default {
    name: "LogDecryptPage",
    data() {
        return {
            //解密日志定义的分割线
            divider: '---------------------',
            appList: [],
            appInfo: {
                appId: -1,
                aesKey: null
            },
            //加密的日志内容
            encryptLog: "",
            //解密之后的日志内容
            decryptLog: "",
            ///选择解密的文件文件名
            fileName: ""
        }
    },
    created() {
        const userInfoStr = window.localStorage.getItem("userInfo")
        if (userInfoStr) {
            this.userInfo = JSON.parse(userInfoStr)
            netWorkController.appList(this.userInfo.id, this.userInfo.accessToken, (result) => {
                if (result.data) {
                    this.appList = result.data
                    let appIdCache = cookieUtils.get("appIdCache")
                    if (appIdCache) {
                        let appId = Number.parseInt(appIdCache);
                        this.appInfo.appId = appId
                        for (let i = 0; i < this.appList.length; i++) {
                            if (this.appList[i].id === appId) {
                                this.appInfo.aesKey = this.appList[i].aesKey
                                break;
                            }
                        }
                    } else {
                        this.appInfo.id = this.appList[0].id
                        this.appInfo.aesKey = this.appList[0].aesKey
                    }
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        }
    },
    methods: {
        onChange(value) {
            if (value) {
                cookieUtils.set("appIdCache", value);
                for (let i = 0; i < this.appList.length; i++) {
                    if (this.appList[i].id === value) {
                        this.appInfo.aesKey = this.appList[i].aesKey
                        break;
                    }
                }
            }
        },
        ///选择日志文件并读取文本内容
        readLogForFile(event) {
            const file = event.target.files[0] // 获取用户选择的文件
            if (file) {
                this.showLoadingDialog('日志读取中...', () => {
                    const reader = new FileReader()
                    reader.readAsText(file) // 以文本形式读取文件内容
                    reader.onload = (ev) => {
                        this.fileName = file.name
                        // 当读取完成时，将文件内容存储在 encryptLog 中
                        this.encryptLog = ev.target.result
                        if (this.loading) {
                            this.loading.close()
                        }
                    }
                })
            }
        },
        ///日志解密
        doDecrypt() {
            if (this.encryptLog.length <= 0) {
                toastUtils.warning(this, "日志内容为空！")
                return
            }
            if (this.appInfo.aesKey <= 0) {
                toastUtils.warning(this, '解密密钥不能为空！')
                return
            }
            this.showLoadingDialog('日志解密中...', () => {
                let result = stringUtils.subString(this.encryptLog, this.divider.trim())
                let decryptContent = ''
                for (let i = 0; i < result.length; i++) {
                    let content = result[i]
                    let decryptStr = aesUtils.aesDecrypt(this.appInfo.aesKey, content)
                    if (decryptStr.length > 0) {
                        decryptContent += decryptStr + '\n'
                    }
                }
                this.decryptLog = decryptContent
                if (this.loading) {
                    this.loading.close()
                }
            })
        },
        ///将日志导出成文本文件
        downloadTextFile() {
            if (this.decryptLog.length <= 0) {
                toastUtils.warning(this, '解密日志内容为空')
                return
            }
            const blob = new Blob([this.decryptLog], {type: 'text/plain'})
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            if (this.fileName) {
                a.download = `decrypt_${this.fileName}`
            } else {
                //获取当前时间戳
                let timestamp = new Date().getTime()
                a.download = `decrypt_Log_${timestamp}.txt`
            }
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            URL.revokeObjectURL(url)
        },

        //清空日志
        clear() {
            this.decryptLog = ''
            this.encryptLog = ''
            this.fileName = ''
            document.getElementById('input_file').value = ''
        },
        ///loading弹框封装，需要延时50毫秒，否则弹框不出来
        showLoadingDialog(title, timerHandler) {
            this.loading = this.$loading({
                lock: true,
                text: title,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            setTimeout(() => {
                timerHandler()
            }, 50)
        }
    }


}